import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// Function to update slide line
function updateSlideLine(activeButton, slideLine) {
    const buttonRect = activeButton.getBoundingClientRect();
    const containerRect = activeButton.parentElement.getBoundingClientRect();
    const leftPosition = buttonRect.left - containerRect.left;
    const width = buttonRect.width;

    slideLine.style.transform = `translateX(${leftPosition}px)`;
    slideLine.style.width = `${width}px`;
}

function updateTabsFromSlider(container, activeIndex) {
    const tabButtons = container.querySelectorAll('.tab-button');
    const tabContents = container.querySelectorAll(
        '[data-tab^="tab-content-"]'
    );
    const slideLine = container.querySelector('.tab-slide-line');

    if (tabButtons[activeIndex]) {
        tabButtons.forEach((btn) => {
            btn.classList.remove(
                'active',
                'max-xl:border-b-2',
                'max-xl:border-(--primary-color)'
            );
        });

        tabContents.forEach((content) => content.classList.add('hidden'));

        tabButtons[activeIndex].classList.add(
            'active',
            'max-xl:border-b-2',
            'max-xl:border-(--primary-color)'
        );

        const targetContent = container.querySelector(
            `[data-tab="tab-content-${activeIndex + 1}"]`
        );
        if (targetContent) {
            targetContent.classList.remove('hidden');
        }

        updateSlideLine(tabButtons[activeIndex], slideLine);
    }
}

// Tabs slider
const tabsSlider = document.querySelectorAll('.tabs-slider-swiper');
const swiperInstances = new Map();

tabsSlider.forEach((sliderElement) => {
    const blockId = sliderElement.getAttribute('data-block-id');
    const swiper = new Swiper(sliderElement, {
        modules: [Navigation],
        loop: false,
        speed: 300,
        slidesPerView: 1,
        height: 'auto',
        autoplay: {
            delay: 2500,
            disableOnInteraction: false,
        },
        navigation: {
            nextEl: `.swiper-custom-next-${blockId}`,
            prevEl: `.swiper-custom-prev-${blockId}`,
        },
        on: {
            slideChange: function () {
                const container = sliderElement.closest('[id^="tabs-slider-"]');
                if (container) {
                    updateTabsFromSlider(container, this.activeIndex);
                }
            },
        },
    });

    swiperInstances.set(sliderElement, swiper);
});
// End Tabs slider

// Tabs functionality
const tabsContainers = document.querySelectorAll('[id^="tabs-slider-"]');

tabsContainers.forEach((container) => {
    const tabButtons = container.querySelectorAll('.tab-button');
    const tabContents = container.querySelectorAll(
        '[data-tab^="tab-content-"]'
    );
    const slideLine = container.querySelector('.tab-slide-line');
    const sliderElement = container.querySelector('.tabs-slider-swiper');
    const swiper = swiperInstances.get(sliderElement);

    if (tabButtons.length > 0) {
        tabButtons[0].classList.add(
            'active',
            'max-xl:border-b-2',
            'max-xl:border-(--primary-color)'
        );
        tabContents[0].classList.remove('hidden');
        updateSlideLine(tabButtons[0], slideLine);
    }

    tabButtons.forEach((button, index) => {
        button.addEventListener('click', () => {
            const containerTabButtons =
                container.querySelectorAll('.tab-button');
            const containerTabContents = container.querySelectorAll(
                '[data-tab^="tab-content-"]'
            );

            containerTabButtons.forEach((btn) => {
                btn.classList.remove(
                    'active',
                    'max-xl:border-b-2',
                    'max-xl:border-(--primary-color)'
                );
            });

            containerTabContents.forEach((content) =>
                content.classList.add('hidden')
            );

            button.classList.add(
                'active',
                'max-xl:border-b-2',
                'max-xl:border-(--primary-color)'
            );

            const targetContent = container.querySelector(
                `[data-tab="tab-content-${index + 1}"]`
            );
            if (targetContent) {
                targetContent.classList.remove('hidden');
            }

            updateSlideLine(button, slideLine);

            if (swiper && swiper.slides && index < swiper.slides.length) {
                swiper.slideTo(index);
            }
        });
    });
});
// End Tabs functionality
